/* Zuriova: restrained reveal-on-scroll. No-op when reduced motion is preferred. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  window.__zReveal = true;

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const observe = (root = document) => root.querySelectorAll('[data-z-reveal]:not(.is-visible)').forEach((el) => io.observe(el));
  observe();
  // Re-scan when sections are re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', (e) => observe(e.target));
})();

/* Zuriova: show the chosen option next to its label, e.g. "Length · 18"". Re-applies after Horizon re-renders the picker. */
(() => {
  const update = () => {
    document.querySelectorAll('fieldset.variant-option').forEach((fs) => {
      const legend = fs.querySelector('legend');
      if (!legend) return;
      const checked = fs.querySelector('input[type="radio"]:checked');
      let tag = legend.querySelector('.z-legend-value');
      const text = checked ? ' \u00b7 ' + checked.value : '';
      if (!tag) { tag = document.createElement('span'); tag.className = 'z-legend-value'; legend.append(tag); }
      if (tag.textContent !== text) tag.textContent = text;
    });
  };
  const schedule = () => requestAnimationFrame(update);
  // Horizon re-renders the picker asynchronously after a selection, so re-apply a few times.
  const settle = () => [0, 350, 900, 1800].forEach((ms) => setTimeout(schedule, ms));
  document.addEventListener('change', (e) => { if (e.target.closest && e.target.closest('fieldset.variant-option')) settle(); });
  document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('fieldset.variant-option')) settle(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  new MutationObserver((list) => {
    if (list.some((m) => (m.target.closest && m.target.closest('variant-picker, .variant-picker, .product-details')) || [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.('fieldset.variant-option, variant-picker, .variant-picker') || n.querySelector?.('fieldset.variant-option'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
})();

/* Zuriova: homepage images below the hero (zuriova-defer-img) wait until the hero image has loaded, the visitor
   scrolls or taps, or 3 s pass, so on phones the hero gets the bandwidth first. They stay loading="lazy". */
(() => {
  if (!document.querySelector('img[data-z-defer]')) return;
  let released = false;
  const release = () => {
    if (released) return;
    released = true;
    document.querySelectorAll('img[data-z-defer]').forEach((img) => {
      if (img.dataset.zSrcset) img.srcset = img.dataset.zSrcset;
      if (img.dataset.zSrc) img.src = img.dataset.zSrc;
      img.removeAttribute('data-z-defer');
    });
  };
  const hero = document.querySelector('.z-hero img');
  if (!hero || hero.complete) return release();
  hero.addEventListener('load', release, { once: true });
  hero.addEventListener('error', release, { once: true });
  ['scroll', 'touchstart', 'pointerdown', 'keydown'].forEach((type) =>
    window.addEventListener(type, release, { once: true, passive: true, capture: true })
  );
  setTimeout(release, 3000);
})();
